import Button from "@ingka/button";

type Props = {
  onPrev: () => void;
  onContinue: () => void;
  disabledPrev?: boolean;
  disabledNext?: boolean;
  isPrevLoading?: boolean;
  isNextLoading?: boolean;
  nextButtonTitle?: string;
  prevButtonTitle?: string;
};

export const NavigationButtons = ({
  onPrev,
  onContinue,
  disabledPrev,
  disabledNext,
  isPrevLoading,
  isNextLoading,
  nextButtonTitle = "Continue",
  prevButtonTitle = "Previous",
}: Props) => {
  return (
    <div className="space-x-space150">
      <Button
        loading={isPrevLoading}
        text={prevButtonTitle}
        type="secondary"
        className="min-w-[164px] bg-white"
        disabled={disabledPrev}
        onClick={onPrev}
      />
      <Button
        loading={isNextLoading}
        text={nextButtonTitle}
        type="emphasised"
        className="min-w-[164px]"
        disabled={disabledNext}
        onClick={onContinue}
      />
    </div>
  );
};
